import React, {useState} from 'react';

// Material-UI
import { Container } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// Components
import NavbarUser from '../components/NavbarUser';
import Background from "../components/BackgroundPattern";
import TitlePage from '../components/TitlePageUser';
import Footer from '../components/Footer';
// Data
import DataKehadiran from '../data/DataKehadiran';

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  image: {
    width: theme.spacing(20)
  },
  section: {
    margin: theme.spacing(2,0)
  },
  table: {
    minWidth: 700,
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TableKehadiran = ( {classes} ) => {
  const [status, setStatusKehadiran] = useState(DataKehadiran)
  const handleStatusKehadiran = (data, index) => {
    if(data.statusKehadiran === "Tidak Hadir") {
      let statusBaru = [...status]
      statusBaru[index] = {
        ...status[index],
        statusKehadiran: "Hadir"
      }
      setStatusKehadiran(statusBaru)
    } else {
      let statusBaru = [...status]
      statusBaru[index] = {
        ...status[index],
        statusKehadiran: "Tidak Hadir"
      }
      setStatusKehadiran(statusBaru)
    }
  }
  
  const tableKehadiran = status.map((data, index) =>
    <StyledTableRow key={data.id}>
      <StyledTableCell component="th" align="justify">
        {data.tanggal}
      </StyledTableCell>
      <StyledTableCell align="justify">{data.namaMateri}</StyledTableCell>
      <StyledTableCell align="justify">
        <FormControlLabel
          control={<Checkbox color="primary" onClick={()=>handleStatusKehadiran(data, index)}/>}
          label={data.statusKehadiran}
          labelPlacement="end"
        />
      </StyledTableCell>
    </StyledTableRow>
  )

  return (
    <section id="table-kehadiran">
      <Container className={classes.section} maxWidth="md">
          <TableContainer component={Paper} elevation={3}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
              <StyledTableCell align="justify">{"Tanggal"}</StyledTableCell>
                <StyledTableCell align="justify">{"Nama Materi"}</StyledTableCell>
                <StyledTableCell align="justify">{"Kehadiran"}</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { tableKehadiran }
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </section>
  );
}

const UserKehadiran = () => {
  const classes = useStyles();

  return (
    <section id="user-kehadiran" className={classes.container}>
      <Background/>
      <NavbarUser/>
        <Container style={{flex: "1"}}>
          <TitlePage text="Kehadiran Materi Pelatihan"/>
          <TableKehadiran classes={classes}/>
        </Container>
      <Footer/>
    </section>
  )
}

export default UserKehadiran
